type WebkitDocument = Document & {
  webkitExitFullscreen?: () => Promise<void> | void;
  webkitFullscreenElement?: Element | null;
};

type WebkitElement = HTMLElement & {
  webkitRequestFullscreen?: () => Promise<void> | void;
};

/** Toggle the browser's real fullscreen mode, including Safari's prefixed API. */
export async function toggleFullscreen(): Promise<boolean> {
  const webkitDocument = document as WebkitDocument;
  const root = document.documentElement as WebkitElement;
  try {
    if (document.fullscreenElement) {
      await document.exitFullscreen();
      return true;
    }
    if (webkitDocument.webkitFullscreenElement && webkitDocument.webkitExitFullscreen) {
      await webkitDocument.webkitExitFullscreen();
      return true;
    }
    if (root.requestFullscreen) {
      await root.requestFullscreen();
      return true;
    }
    if (root.webkitRequestFullscreen) {
      await root.webkitRequestFullscreen();
      return true;
    }
  } catch {
    return false;
  }
  return false;
}
